import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';

const ComplianceCertifications = () => {
  return (
    <>
      <SEO 
        title="Compliance & Certifications - Abacies Logiciels"
        description="Learn about Abacies Logiciels' compliance standards, industry certifications, security certifications, and regulatory compliance including ISO, SOC, and industry-specific standards."
        keywords="compliance, certifications, ISO certification, SOC compliance, security certifications, regulatory compliance"
      />

      <section className="hero-section">
        <div className="page-container">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-charcoal animate-fade-in">
              Compliance & Certifications
            </h1>
            <p className="text-xl text-titanium leading-relaxed animate-slide-up">
              This is the Compliance & Certifications page with sample content.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-white">
        <div className="page-container">
          <div className="max-w-4xl mx-auto">
            <p className="text-titanium mb-6">
              Sample content for Compliance & Certifications. This page contains placeholder text and will be updated with actual content.
            </p>
            <Link to="/" className="btn-primary">Return Home</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default ComplianceCertifications;
